export default "__VITE_ASSET__CRHbycND__"